import React from "react";
import { Form, Image } from "react-bootstrap";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Win: React.FC = () => {
    const yearStarted = new Date("2020").getFullYear();
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    const createYearOptions = () => {
        let options: JSX.Element[] = [];
        for (let i = currentYear; i >= yearStarted; i--) {
            options.push(<option value={`${i}`} selected={currentYear === i ? true : false}>{i}年</option>)
        }
        return options;
    }

    const createMonthOptions = () => {
        let options: JSX.Element[] = [];
        for (let i = 12; i > 0; i--) {
            options.push(<option value={`${i}`} selected={currentMonth + 1 === i ? true : false}>{i}月</option>)
        }
        return options;
    }

    return (
        <>
            <section className="section-table-theme user-management">
                <div className="container">
                    <div className="text-center border-bottom-5-blue-05 mb-4">
                        <Image className="height-90 mb-2" src="assets/images/other/icon-court-hammer.svg" />
                        <div className="text-md mb-sm-4 mb-3 fw-400">落札履歴</div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 order-lg-2">
                            <div className="text-lg-end text-start">
                                <Image className="height-30 mb-3 d-inline-block me-2" src="assets/images/other/icon-building-crossways-green.svg" />
                                <div className="text-md fw-400 d-inline-block"><span className="text-xl text-blue-04 fw-300 me-2">0</span>社 表示中</div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="search-wrapper form-theme">
                                <Form.Label htmlFor="customSelect">絞り込み</Form.Label>
                                <Form.Select className="custom-select theme-form-select text-theme ms-2 w-max-130" id="customSelect"
                                    style={{ display: "inline" }}>
                                    {createYearOptions()}
                                </Form.Select>
                                <Form.Select className="custom-select theme-form-select text-theme ms--4 w-max-100" id="customSelect"
                                    style={{ display: "inline" }}>
                                    {createMonthOptions()}
                                </Form.Select>
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive overflow-y-unset fixed-header mb-lg-5 mb-4 tableFixHead">
                        <table className="table table-borderless table-theme table-vertical-align-middle table-fixed inner-btn-w-80">
                            <thead>
                                <tr>
                                    <th className=""></th>
                                    <th className="text-start w-min-450 fw-300">会社名</th>
                                    <th className="w-min-250 text-start fw-300">落札日</th>
                                    <th className=""></th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* <tr className="border-bottom">
                                    <td><span className="bg-ass-deep-demo-02 text-white bg-color-text">契約完了</span></td>
                                    <td className="text-start w-min-450">テストコーポレーション株式会社</td>
                                    <td className="text-start w-min-250">2020/10/13</td>
                                    <td className="text-left"><a href="#" className="text-blue-deep-theme">詳しく見る ＞</a></td>
                                </tr>
                                <tr className="border-bottom">
                                    <td className=""><span className="bg-blue-04 text-white bg-color-text">手続中</span></td>
                                    <td className="text-start w-min-450">テストコーポレーション株式会社</td>
                                    <td className="text-start w-min-250">2021/1/12</td>
                                    <td className="text-left"><a href="#" className="text-blue-deep-theme">詳しく見る ＞</a></td>
                                </tr>
                                <tr className="border-bottom">
                                    <td><span className="bg-ass-deep-demo-02 text-white bg-color-text">他社落札</span></td>
                                    <td className="text-start w-min-450">テストコーポレーション株式会社</td>
                                    <td className="text-start w-min-250">2021/1/20</td>
                                    <td className="text-left"><a href="#" className="text-blue-deep-theme">詳しく見る ＞</a></td>
                                </tr> */}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Win;